import i18n from '@/plugins/i18n'
export default (app: any) => {
  app.use(i18n)
}
